export enum ImageOverlayType {
    None = "none",
    Affirmative = "affirmative",
    Negative = "negative"
}
